(function () {
  "use strict";

  /* =========================================
     COUNTDOWN
  ========================================= */

  function initCountdowns() {
    const countdowns = document.querySelectorAll(
      ".kp-countdown[data-countdown]"
    );

    countdowns.forEach(function (countdown) {

      const endDateString = countdown.dataset.countdown;

      if (!endDateString) return;

      const endDate = new Date(endDateString).getTime();

      if (isNaN(endDate)) return;

      function updateCountdown() {

        const now = new Date().getTime();
        const distance = endDate - now;

        const days = countdown.querySelector("[data-days]");
        const hours = countdown.querySelector("[data-hours]");
        const minutes = countdown.querySelector("[data-minutes]");
        const seconds = countdown.querySelector("[data-seconds]");

        if (distance <= 0) {

          if (days) days.textContent = "00";
          if (hours) hours.textContent = "00";
          if (minutes) minutes.textContent = "00";
          if (seconds) seconds.textContent = "00";

          countdown.classList.add("is-expired");

          return;
        }

        const d = Math.floor(
          distance / (1000 * 60 * 60 * 24)
        );

        const h = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) /
          (1000 * 60 * 60)
        );

        const m = Math.floor(
          (distance % (1000 * 60 * 60)) /
          (1000 * 60)
        );

        const s = Math.floor(
          (distance % (1000 * 60)) /
          1000
        );

        if (days) {
          days.textContent = String(d).padStart(2, "0");
        }

        if (hours) {
          hours.textContent = String(h).padStart(2, "0");
        }

        if (minutes) {
          minutes.textContent = String(m).padStart(2, "0");
        }

        if (seconds) {
          seconds.textContent = String(s).padStart(2, "0");
        }
      }

      updateCountdown();

      const timer = setInterval(function () {

        updateCountdown();

        if (countdown.classList.contains("is-expired")) {
          clearInterval(timer);
        }

      }, 1000);

    });
  }


  /* =========================================
     COPY COUPON
  ========================================= */

  function initCouponCopy() {

    const buttons = document.querySelectorAll(
      ".kp-copy-button[data-copy-coupon]"
    );

    buttons.forEach(function (button) {

      button.addEventListener("click", async function () {

        const code = button.dataset.copyCoupon;

        if (!code) return;

        try {

          await navigator.clipboard.writeText(code);

        } catch (error) {

          const textarea = document.createElement("textarea");

          textarea.value = code;

          textarea.style.position = "fixed";
          textarea.style.opacity = "0";

          document.body.appendChild(textarea);

          textarea.focus();
          textarea.select();

          document.execCommand("copy");

          textarea.remove();

        }

        const couponArea = button.closest(
          ".kp-coupon__code-area"
        );

        if (!couponArea) return;

        const success = couponArea.querySelector(
          ".kp-copy-success"
        );

        const buttonText = button.querySelector(
          ".kp-copy-text"
        );

        if (success) {
          success.classList.add("is-visible");
        }

        if (buttonText) {
          buttonText.textContent = "COPIED!";
        }

        setTimeout(function () {

          if (success) {
            success.classList.remove("is-visible");
          }

          if (buttonText) {
            buttonText.textContent = "COPY CODE";
          }

        }, 2500);

      });

    });

  }


  /* =========================================
     INITIALIZE
  ========================================= */

  function initOffers() {
    initCountdowns();
    initCouponCopy();
  }


  if (document.readyState === "loading") {

    document.addEventListener(
      "DOMContentLoaded",
      initOffers
    );

  } else {

    initOffers();

  }


  /* =========================================
     SHOPIFY THEME EDITOR
  ========================================= */

  document.addEventListener(
    "shopify:section:load",
    function () {
      initOffers();
    }
  );

})();